import { useCallback } from "react";
import useSWR from "swr";
import { useApi } from "../api";
import { CustomError } from "../errors";
import { DefaultTaskCategory } from "./types";

export const useDefaultTaskCategoriesApi = () => {
  const api = useApi();

  const useAdminDefaultTaskCategories = useCallback(
    (signal: AbortSignal) => {
      const url = `/admin/default_task_categories`;
      return useSWR<DefaultTaskCategory[] | null, CustomError, string>(url, (url) =>
        api.get<DefaultTaskCategory[]>({ url, signal })
      );
    },
    [api]
  );

  return {
    useAdminDefaultTaskCategories,
  };
};
